import { useContext, useState } from "react";
import { createProfile, updateProfile } from "endpoints/profile";
import { selfRegisterCustomer } from "endpoints/auth";
import { useMutation } from "react-query";
import { RequestLoader } from "context";
import {
  getCustomerLoyaltyId,
  getRandomIntInclusive,
  normalizeDateOfBirth,
} from "helpers";

const useCustomerBioData = ({ type, data, onSuccessCall }) => {
  const token = data?.token;
  const accessNumber = data?.phoneNumber;
  const [firstName, setFirstName] = useState(data?.firstName || "");
  const [lastName, setLastName] = useState(data?.lastName || "");
  const [middleName, setMiddleName] = useState(data?.middleName || "");
  const [email, setEmail] = useState(data?.email || "");
  const [phoneNumber, setPhoneNumber] = useState(
    accessNumber ? accessNumber : "",
  );
  const [gender, setGender] = useState(data?.gender || "MALE");
  const [dob, setDob] = useState(data?.dob || "");

  const { isLoading, mutate: updateBio } = useMutation((data) => {
    if (type === "self-register") return selfRegisterCustomer(data);
    if (type === "create") return createProfile(data);
    return updateProfile(data);
  });
  const { setRequestLoaderProgress } = useContext(RequestLoader);

  const triggerBioUpdate = () => {
    setRequestLoaderProgress(getRandomIntInclusive(20, 40));
    updateBio(
      {
        ...(type === "self-register"
          ? {
              first_name: firstName,
              last_name: lastName,
              email,
              phone_number: phoneNumber,
              phone_code: data?.phoneCode,
              gender,
              business_slug: data?.businessSlug,
              ...(/^\d{4}-\d{2}-\d{2}$/.test(normalizeDateOfBirth(dob))
                ? { date_of_birth: normalizeDateOfBirth(dob) }
                : {}),
              ...(data?.storeId ? { store_id: data.storeId } : {}),
            }
          : {
              data: {
                first_name: firstName,
                last_name: lastName,
                middle_name: middleName === "" ? null : middleName,
                email: email,
                phone: `+234${phoneNumber}`,
                gender: gender,
                date_of_birth: /^\d{4}-\d{2}-\d{2}$/.test(
                  normalizeDateOfBirth(dob),
                )
                  ? normalizeDateOfBirth(dob)
                  : null,
              },
              others: {
                loyalty_id: getCustomerLoyaltyId(token),
                token: token,
              },
            }),
      },
      {
        onSuccess: (response) => {
          setRequestLoaderProgress(100);
          onSuccessCall(response);
        },
      },
    );
  };

  return {
    isLoading,
    firstName,
    lastName,
    middleName,
    email,
    phoneNumber,
    gender,
    dob,
    setFirstName,
    setLastName,
    setMiddleName,
    setEmail,
    setPhoneNumber,
    setGender,
    setDob,
    triggerBioUpdate,
  };
};
export default useCustomerBioData;
